module.exports = __webpack_public_path__ + "static/media/inaamCards.6589a98c.svg";